export default {
    app: {
        super_admin_role: 'Super Admin'
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/env.js